import { Apis, Constants, Enums, Helpers, Store } from "utils";
import { IMessage } from "interfaces";

export interface IMessageService {
  chats(): Promise<any>;
  chat(id: number, offset?: number, count?: number): Promise<any>;
  send(senderId: number, receiverId: number, message: string, messageTime: Date): Promise<any>;
}

export class MessageService implements IMessageService {
  private qubehub: any;
  private controllerName: string = "message";

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  /**
   * fetch all the chats of an user
   * @returns
   */

  async chats() {
    try {
      const [status, response] = this.#handleResponse(await this.qubehub.get(this.controllerName));
      return response ?? [];
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * fetch all the messages of a chat
   * @param {number} id receiver user id
   * @param {number} offset starting point for pagination purposes e.g. 10 it will get from appointment 10 - 10 + count
   * @param {number} count quatity of appointments to fetch e.g. 10 it will get 10 appointments starting point + 10
   * @returns
   */

  async chat(id: number, offset: number = 0, count: number = Constants.PAGE_LENGTH) {
    try {
      const URL = Helpers.interpolateURL(this.controllerName + "/participant/:participantId", { participantId: id });
      const [status, response] = this.#handleResponse(await this.qubehub.get(Helpers.toQueryString(URL, { offset, count })));
      return response ?? {};
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * send a message to the clinic
   * @param {number} receiverId user id
   * @param {string} message the content of the message
   * @param {string} messageTime the time when the message was sent
   * @returns
   */

  async send(senderId: number, receiverId: number, message: string, messageTime: Date) {
    try {
      const URL = Helpers.interpolateURL(this.controllerName + "/receiver/:receiverId", { receiverId });
      this.#handleResponse(await this.qubehub.post(URL, { message, messageTime: Helpers.toOffsetString(messageTime) }));
      return {
        messageId: -1,
        senderId,
        receiverId,
        content: message,
        messageTime: Helpers.toOffsetString(messageTime),
        received: true,
      } as IMessage;
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  /**
   * method to handle the response from the API
   * @param {any} response the data retrieved from the API
   * @returns
   */

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}

export default MessageService;
